export const TYPESENSE_HISTORY = 'TYPESENSE_HISTORY';
export const CHUNK_LOAD_RETRIES = 'CHUNK_LOAD_RETRIES';
export const LAST_SEEN_PRODUCTS = 'LAST_SEEN_PRODUCTS';
export const NEWSLETTER_SUBSCRIPTION = 'NEWSLETTER_SUBSCRIPTION';
export const ORDER_HISTORY_MOCK = 'ORDER_HISTORY_MOCK';
export const PARTNERS_TRANSITION_BANNER_DISMISSED = 'PARTNERS_TRANSITION_BANNER_DISMISSED';
